// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3Ww2J","buttons":"RemoveExpirationActionButtons_buttons__26qn4"};